lmApp.service('RailResource', ['$resource', function ($resource) {
  return $resource('/discovery:80/sdp/v2/rails',
    null,
      {
        get: {
          params: {},
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
          },
          isArray: true,
          transformResponse: function (data) {
            var result = angular.fromJson(data);
            if (result && result.data) return result.data;
            return [];
          }
        },
        getScreens: {
          url: '/discovery:80/sdp/v2/screens',
          method: 'GET',
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken'),
          },
          isArray: true,
          transformResponse: function (data) {
            var result = angular.fromJson(data);
            if (result && result.data) return result.data;
            return [];
          }
        },
        patchScreen: {
          url: '/discovery:80/sdp/v2/screens/:id',
          method: 'PATCH',
          params: {
            id: '@id'
          },
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
          }
        },
        createScreen: {
          url: '/discovery:80/sdp/v2/screens',
          method: 'POST',
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
          }
        },
        createRail: {
          url: '/discovery:80/sdp/v2/rails',
          method: 'POST',
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
          }
        },
        removeScreen: {
          url: '/discovery:80/sdp/v2/screens/:id',
          method: 'DELETE',
          params: {
            id: '@id'
          },
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
          }
        },
        patch: {
          url: '/discovery:80/sdp/v2/rails/:id',
          method: 'PATCH',
          params: {
            id: '@id'
          },
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
          }
        },
        remove: {
          url: '/discovery:80/sdp/v2/rails/:id',
          method: 'DELETE',
          params: {
            id: '@id'
          },
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
          }
        },
        getRailContent: {
          params: {
            id: '@id'
          },
          url: '/discovery:80/sdp/v2/rails/:id/content?$expand=asset(*)',
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
          },
          isArray: true,
          transformResponse: function (data) {
            var result = angular.fromJson(data);
            if (result && result.data) return result.data;
            return [];
          }
        },
        setPackageAssets: {
          url: '/discovery:80/sdp/v2/assets/:id/package-assets',
          method: 'PUT',
          params: {
            id: '@id'
          },
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
          }
        },
      }
  );
}]);
